import React from 'react';
import { PostLocation } from '@sprinklr/stories/post/Post';
import NativeFlex from 'components/NativePost/Bits/NativeFlex';
import { getNativeColor } from 'components/NativePost/Helpers';
import { Avatar } from 'components/spaceKit';
import styled, { css } from 'components/_UI/designSystem';
import { getLocationString, hasValidLocation } from 'utils/PostUtils/PostUtils';
import { theme } from './constants';
import { StyledPostProps } from './types';

export const StyledNativeProfileLockup = styled(NativeFlex)``;

export const StyledTimeStamp = styled.div`
    font-size: 0.7em;
    ${({ colorMode }: StyledPostProps) =>
        css`
            color: ${getNativeColor(theme, colorMode, 'secondary')};
        `}
`;

export const StyledLocation = ({
    colorMode,
    location,
}: {
    colorMode: any;
    location: PostLocation;
}) =>
    hasValidLocation(location) && (
        <React.Fragment key='locationInfo'>
            <StyledTimeStamp colorMode={colorMode}>•</StyledTimeStamp>
            <StyledTimeStamp colorMode={colorMode}>{getLocationString(location)}</StyledTimeStamp>
        </React.Fragment>
    );

export const StyledUserName = styled.div`
    font-weight: bold;
    font-size: 0.9em;
    line-height: 1.2;
    word-break: break-word;
    ${({ colorMode }: StyledPostProps) =>
        css`
            color: ${getNativeColor(theme, colorMode, 'userName')};
        `}
`;
export const StyledSecondaryName = styled.div`
    font-size: 0.7em;
    line-height: 1.2;
    word-break: break-word;
    ${({ colorMode }: StyledPostProps) =>
        css`
            color: ${getNativeColor(theme, colorMode, 'secondary')};
        `}
`;
export const StyledAvatar = styled(Avatar)`
    height: 2.5em;
    width: 2.5em;
`;
